import { RestSlice } from '../../../../redux/rest.slice';
import { CccHazard } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const cccHazardSlice = new RestSlice<CccHazard>(
	localizationService.getLocalizedString('cccHazard.hazards'),
	Resource.CccHazards
);
export const cccHazardsReducer = cccHazardSlice.rests.reducer;
